export default "__VITE_ASSET__dA0CkGV1__"